import React from 'react';

import imgClassActionFileClaim from 'images/img_class_action_file_claim.svg';
import imgClassActionFindCase from 'images/img_class_action_find_case.svg';
import imgClassActionGetCompensated from 'images/img_class_action_get_compensated.svg';

import {
  ClassActionGuideIllustration,
  ClassActionGuideOuter,
  ClassActionGuideRow,
  ClassActionGuideStepBlock,
  ClassActionGuideStepBody,
  ClassActionGuideStepTitle,
  ClassActionGuideTextStack,
} from './components';

const GUIDE_STEPS = [
  {
    id: 'find-case',
    title: 'Find A Case',
    description:
      'Browse active class action lawsuits and settlements to see which ones you may qualify for.',
    imageSrc: imgClassActionFindCase,
  },
  {
    id: 'file-claim',
    title: 'File A Claim',
    description:
      'Complete a quick claim form with the required details and submit it to participate in the case.',
    imageSrc: imgClassActionFileClaim,
  },
  {
    id: 'get-compensated',
    title: 'Get Compensated',
    description:
      "If the case settles and your claim is approved, you'll receive your share of the settlement.",
    imageSrc: imgClassActionGetCompensated,
  },
] as const;

export const ClassActionProcessGuideCards: React.FC<{
  testId?: string;
}> = ({ testId = 'class-action-process-guide' }) => (
  <ClassActionGuideOuter data-testid={testId}>
    <ClassActionGuideRow>
      {GUIDE_STEPS.map(({ id, title, description, imageSrc }) => (
        <ClassActionGuideStepBlock key={id}>
          <ClassActionGuideIllustration aria-hidden>
            <img src={imageSrc} alt="" />
          </ClassActionGuideIllustration>
          <ClassActionGuideTextStack>
            <ClassActionGuideStepTitle component="h3">
              {title}
            </ClassActionGuideStepTitle>
            <ClassActionGuideStepBody>{description}</ClassActionGuideStepBody>
          </ClassActionGuideTextStack>
        </ClassActionGuideStepBlock>
      ))}
    </ClassActionGuideRow>
  </ClassActionGuideOuter>
);

export default ClassActionProcessGuideCards;
